import { Component, OnInit } from '@angular/core';
import { Notification, NotificationsService } from '../notification/notifications.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'grid-notification-bar',
  templateUrl: './grid-notification-bar.component.html',
  styleUrls: ['./grid-notification-bar.component.scss'],
  providers: [NotificationsService],
})
export class GridNotificationBarComponent implements OnInit {
  notifications$!: Observable<Notification[]>;

  constructor(private notificationsService: NotificationsService) { }

  ngOnInit() {
    this.notifications$ = this.notificationsService.getNotifications().pipe(
      map(notifications => notifications.filter(notification => notification.originator === 'tickets')),
    );
  }

  closeNotification(notification: Notification): void {
    this.notificationsService.removeNotification(notification);
  }
}
